
import angular from "angular";

import Assert from "tbAssert";

import UserInfoServiceModule from "../../services/UserInfoService";

import ReportsMainPageModule from "./ReportsMainPage";
import TrackingTargetEventsReportModule from "./TrackingTargetEventsReport";
import SomeDaysEventsReportModule from "./SomeDaysEventsReport";
import TrackingSummaryReportModule from "./TrackingSummaryReport";
import StateEventCountReportModule from "./StateEventCountReport";

const reportShellPageTitle = "TrackerBase: TrackerBase Reports";

const mAnchorScrollSvc = new WeakMap();
const mUserInfoSvc = new WeakMap();
const mShowSideDrawer = new WeakMap();

const mReportList = new WeakMap();

class TrackingReportsViewShellController {
    constructor($document, $anchorScroll, UserInfoService) {
        Assert.StrictAssert($document != null, "Assertion Failure: Missing Document Service Dependency");
        Assert.StrictAssert($anchorScroll != null, "Assertion Failure: Missing Anchor Scroll Service Dependency");
        Assert.StrictAssert(UserInfoService != null, "Assertion Failure: Missing User Info Service Dependency");

        mAnchorScrollSvc.set(this, $anchorScroll);
        mUserInfoSvc.set(this, UserInfoService);
        mShowSideDrawer.set(this, false);

        $document.attr("title", reportShellPageTitle);

        let installedReportConfigurations = [];

        [
            ReportsMainPageModule,
            TrackingTargetEventsReportModule,
            SomeDaysEventsReportModule,
            TrackingSummaryReportModule,
            StateEventCountReportModule
        ]
        .map((reportModule) => reportModule.configs)
        .forEach((reportConfigurations) => {
            Array.prototype.push.apply(installedReportConfigurations, reportConfigurations);
        });

        mReportList.set(this,
            installedReportConfigurations.filter((config) => (config.showReportInMenu === true))
        );

    }

    $onInit() {
        const shellHeaderPanelId = "#tbReportsShellHeaderPanel";
        mAnchorScrollSvc.get(this).yOffset = angular.element(shellHeaderPanelId);
    }

    get userInfo() {
        return mUserInfoSvc.get(this);
    }

    get showSideDrawer() {
        return mShowSideDrawer.get(this);
    }

    get reportList() {
        return mReportList.get(this);
    }

    toggleSidebar() {
        mShowSideDrawer.set(this, (!this.showSideDrawer));
    }
}

TrackingReportsViewShellController.$inject = [
    "$document",
    "$anchorScroll",
    "UserInfoService"
];

TrackingReportsViewShellController.dependencies = [
    "ngSanitize",
    "ngAnimate",
    "ngAria",
    "ui.bootstrap",
    UserInfoServiceModule,
    ReportsMainPageModule.moduleName,
    TrackingTargetEventsReportModule.moduleName,
    SomeDaysEventsReportModule.moduleName,
    TrackingSummaryReportModule.moduleName,
    StateEventCountReportModule.moduleName
];

TrackingReportsViewShellController.template = require("./ReportsShell.tpl.html");

TrackingReportsViewShellController.controllerAs = "reportsViewShell";

export default TrackingReportsViewShellController;



//////////////////
// WEBPACK FOOTER
// ./src/views/trackerbase-reports/ReportsViewShellController.js
// module id = Talj
// module chunks = 1